<!-- SETTINGS COMPONENT -->
<div class="settings-component">
    <div class="settings-container">

        <!-- PAGE HEADER -->
        <div class="page-header">
        </div>

        <!-- FILTERS SECTION (Styled like Profile) -->
        <div class="filters-section">
            <div class="filters-row">
                <div class="filter-chip" [class.active]="activeTab === 'general'" (click)="switchTab('general')">
                    General
                </div>
                <div *ngIf="_isRoleName == 'admin'" class="filter-chip" [class.active]="activeTab === 'reasons'"
                    (click)="switchTab('reasons')">
                    Reasons
                </div>
            </div>
        </div>

        <!-- GENERAL TAB CONTENT -->
        <div class="tab-content" [class.active]="activeTab === 'general'">
            <div *ngIf="!isLoading; else generalSkeleton">
                <!-- Settings Grid Layout -->
                <div class="settings-grid">
                    <!-- Archive Orders Card -->
                    <div *ngIf="_isRoleName =='admin'" class="setting-card">
                        <!-- ... existing content ... -->
                        <div class="setting-header">
                            <div class="setting-icon-wrapper archive">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                                </svg>
                            </div>
                            <div class="setting-header-text">
                                <h3 class="setting-title">Archive Orders</h3>
                                <p class="setting-description">Automatically archive completed orders</p>
                            </div>
                        </div>
                        <div class="setting-options">
                            <button class="option-btn" [class.active]="archiveOrders === 2"
                                (click)="selectArchiveOption(2)">
                                <span class="option-text">2 Days</span>
                            </button>
                            <button class="option-btn" [class.active]="archiveOrders === 7"
                                (click)="selectArchiveOption(7)">
                                <span class="option-text">7 Days</span>
                            </button>
                            <button class="option-btn" [class.active]="archiveOrders === 10"
                                (click)="selectArchiveOption(10)">
                                <span class="option-text">10 Days</span>
                            </button>
                            <button class="option-btn" [class.active]="archiveOrders === 4" (click)="openManualPopup()">
                                <span class="option-text">Manual</span>
                            </button>
                        </div>
                    </div>

                    <!-- Clear Notifications Card -->
                    <div class="setting-card">
                        <div class="setting-header">
                            <div class="setting-icon-wrapper notifications">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                </svg>
                            </div>
                            <div class="setting-header-text">
                                <h3 class="setting-title">Clear Notifications</h3>
                                <p class="setting-description">Remove old notifications automatically</p>
                            </div>
                        </div>
                        <div class="setting-options">
                            <button class="option-btn" [class.active]="clearNotifications === 1"
                                (click)="selectClearOption(1)">
                                <span class="option-text">1 Month</span>
                            </button>
                            <button class="option-btn" [class.active]="clearNotifications === 2"
                                (click)="selectClearOption(2)">
                                <span class="option-text">2 Months</span>
                            </button>
                            <button class="option-btn" [class.active]="clearNotifications === 3"
                                (click)="selectClearOption(3)">
                                <span class="option-text">3 Months</span>
                            </button>
                        </div>
                    </div>

                    <!-- Departure Time Card -->
                    <div *ngIf="_isRoleName =='admin'" class="setting-card">
                        <div class="setting-header">
                            <div class="setting-icon-wrapper time">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div class="setting-header-text">
                                <h3 class="setting-title">Departure Time</h3>
                                <p class="setting-description">Set default departure time</p>
                            </div>
                        </div>
                        <div class="setting-time-wrapper">
                            <input class="time-input-clean" [ngxTimepicker]="departureTimePicker" readonly
                                [value]="departureTime" placeholder="Select Time">
                            <ngx-material-timepicker #departureTimePicker [defaultTime]="getTime()" [format]="12"
                                (timeSet)="onTimeSelected($event)">
                            </ngx-material-timepicker>
                        </div>
                    </div>
                        <div *ngIf="_isRoleName == 'admin'" class="setting-card">
  <div class="setting-header">
    <div class="setting-icon-wrapper time">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
    </div>
    <div class="setting-header-text">
      <h3 class="setting-title">Signature Requirement</h3>
      <p class="setting-description">Set default signature requirement</p>
    </div>
  </div>

  <label class="toggle-option success" [class.disabled-toggle]="!showadminsblock">
    <div class="toggle-option-content">
      <div class="toggle-option-icon">✓</div>
      <span class="toggle-option-label">Required Signature </span>
    </div>
    <input type="checkbox"
           [checked]="require_delivery_signature"
           (change)="toggleSignatureRequired($event)">
    <div class="toggle-btn"></div>
  </label>
</div>
                </div>

                <!-- Notification Preferences Section -->
                <div class="preferences-section">
                    <h2 class="preferences-title">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="preferences-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                        </svg>
                        Notification Preferences
                    </h2>

                    <!-- Receive Notifications -->
                    <div class="preference-card">
                        <div class="preference-header">
                            <div class="preference-label">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor" class="preference-icon">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                                </svg>
                                Push Notifications
                            </div>
                            <span class="preference-subtitle">Choose which order statuses trigger push notifications</span>
                        </div>
                        <div class="toggle-options">
                            <label class="toggle-option success" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">✓</div>
                                    <span class="toggle-option-label">Successful</span>
                                </div>
                                <input type="checkbox" [checked]="pushNotifications.successful"
                                    (change)="togglePushNotification('successful', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option danger" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">✕</div>
                                    <span class="toggle-option-label">Unsuccessful</span>
                                </div>
                                <input type="checkbox" [checked]="pushNotifications.unsuccessful"
                                    (change)="togglePushNotification('unsuccessful', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option info" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">⊘</div>
                                    <span class="toggle-option-label">Cancelled</span>
                                </div>
                                <input type="checkbox" [checked]="pushNotifications.cancelled"
                                    (change)="togglePushNotification('cancelled', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                        </div>
                    </div>

                    <!-- Receive Emails -->
                    <div class="preference-card">
                        <div class="preference-header">
                            <div class="preference-label">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor" class="preference-icon">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                </svg>
                                Email Notifications
                            </div>
                            <span class="preference-subtitle">Get email updates for order status changes</span>
                        </div>
                        <div class="toggle-options">
                            <label class="toggle-option neutral" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">→</div>
                                    <span class="toggle-option-label">Enroute</span>
                                </div>
                                <input type="checkbox" [checked]="emailNotifications.enroute"
                                    (change)="toggleEmailNotification('enroute', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option neutral" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">📦</div>
                                    <span class="toggle-option-label">Shipped</span>
                                </div>
                                <input type="checkbox" [checked]="emailNotifications.shipped"
                                    (change)="toggleEmailNotification('shipped', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option success" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">✓</div>
                                    <span class="toggle-option-label">Successful</span>
                                </div>
                                <input type="checkbox" [checked]="emailNotifications.successful"
                                    (change)="toggleEmailNotification('successful', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option danger" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">✕</div>
                                    <span class="toggle-option-label">Unsuccessful</span>
                                </div>
                                <input type="checkbox" [checked]="emailNotifications.unsuccessful"
                                    (change)="toggleEmailNotification('unsuccessful', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option info" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">⊘</div>
                                    <span class="toggle-option-label">Cancelled</span>
                                </div>
                                <input type="checkbox" [checked]="emailNotifications.cancelled"
                                    (change)="toggleEmailNotification('cancelled', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                        </div>
                    </div>

                    <!-- Receive SMS -->
                    <div class="preference-card">
                        <div class="preference-header">
                            <div class="preference-label">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor" class="preference-icon">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                </svg>
                                SMS Notifications
                            </div>
                            <span class="preference-subtitle">Receive text message alerts</span>
                        </div>
                        <div class="toggle-options">
                            <label class="toggle-option neutral" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">→</div>
                                    <span class="toggle-option-label">Enroute</span>
                                </div>
                                <input type="checkbox" [checked]="smsNotifications.enroute"
                                    (change)="toggleSMSNotification('enroute', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                            <label class="toggle-option neutral" [class.disabled-toggle]="!showadminsblock">
                                <div class="toggle-option-content">
                                    <div class="toggle-option-icon">📦</div>
                                    <span class="toggle-option-label">Shipped</span>
                                </div>
                                <input type="checkbox" [checked]="smsNotifications.shipped"
                                    (change)="toggleSMSNotification('shipped', $event)">
                                <div class="toggle-btn"></div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Grant Settings Permission Section -->
            <div *ngIf="_isRoleName =='admin' && showadminsblock" class="preferences-section">
                <h2 class="preferences-title">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor" class="preferences-icon">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                    </svg>
                    Grant Settings Permission
                </h2>

                <div *ngIf="!isLoading; else permissionSkeleton" class="permission-grid">
                    <label class="permission-card" *ngFor="let admin of admins">
                        <div class="permission-content">
                            <div class="permission-name">{{ admin.name }}</div>
                        </div>
                        <input type="checkbox" [checked]="admin.can_change_settings"
                            (change)="toggleAdminPermission(admin, $event)">
                        <div class="permission-toggle"></div>
                    </label>
                </div>
            </div>

        </div>
        <!-- END GENERAL TAB -->

        <!-- REASONS TAB CONTENT -->
        <div class="tab-content" [class.active]="activeTab === 'reasons'">

            <!-- Reasons Header -->
            <div class="reasons-header">
                <div class="filters-row">
                    <div class="filter-chip" [class.active]="activeReasonType === 'unsuccessful'"
                        (click)="switchReasonType('unsuccessful')">
                        Order Unsuccessful
                        <span class="count">{{ unsuccessfulCount }}</span>
                    </div>
                    <div class="filter-chip" [class.active]="activeReasonType === 'cancelled'"
                        (click)="switchReasonType('cancelled')">
                        Order Cancel
                        <span class="count">{{ cancelCount }}</span>
                    </div>
                </div>
                <div class="search-wrapper header-search">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor" class="search-icon">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                    </svg>
                    <input type="text" class="search-input" placeholder="Search reasons..." [(ngModel)]="searchQuery"
                        (input)="onSearchChange(searchQuery)" title="Search Reasons">
                    <svg *ngIf="cross" (click)="clearText()" class="cross-icon" width="16" height="16"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <button class="btn-add-reason" (click)="openAddReasonModal()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Add Reason
                </button>
            </div>

            <!-- Reasons Table -->
            <div class="section-card">
                <table class="reasons-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Reason</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="!isLoading; else tableSkeleton">
                        <tr *ngFor="let reason of reasons; let i = index">
                            <td class="reason-number">{{ reason.sNo }}</td>
                            <td class="reason-text">{{ reason.reason_text }}</td>
                            <td>
                                <div class="reason-actions">
                                    <button class="btn-icon-action" (click)="editReason(reason)" title="Edit Reason">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                        </svg>
                                    </button>
                                    <button class="btn-icon-action delete delete-btn" (click)="deleteReason(reason.id)" title="Delete Reason">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Pagination -->
                <div class="pagination">
                    <!-- <div class="pagination-info">{{ getPaginationInfo() }}</div> -->
                    <div class="pagination-controls">
                        <button class="pagination-btn" (click)="changePage('prev')" [disabled]="currentPage === 1" title="Previous Page">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                            </svg>
                        </button>
                        <div class="pagination-info">
                            <!-- Page {{ currentPage }} of {{ totalPages }} -->
                            {{ getPaginationInfo() }}
                        </div>
                        <button class="pagination-btn" (click)="changePage('next')"
                            [disabled]="currentPage === totalPages" title="Next Page">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <!-- END REASONS TAB -->

    </div>
</div>
<!-- END SETTINGS COMPONENT -->

<!-- SKELETON TEMPLATES -->
<ng-template #generalSkeleton>
    <div class="skeleton-setting-card" *ngFor="let i of [1,2,3]">
        <div class="skeleton-setting-header">
            <div class="skeleton-icon skeleton-block"></div>
            <div class="skeleton-header-text">
                <div class="skeleton-title skeleton-block"></div>
                <div class="skeleton-desc skeleton-block"></div>
            </div>
        </div>
        <div class="skeleton-options">
            <div class="skeleton-option-btn skeleton-block" *ngFor="let j of [1,2,3,4]"></div>
        </div>
    </div>
    
    <div class="preferences-section skeleton-preferences-section">
        <div class="skeleton-preference-card" *ngFor="let i of [1,2,3]">
            <div class="skeleton-pref-header">
                <div class="skeleton-pref-label skeleton-block"></div>
                <div class="skeleton-pref-subtitle skeleton-block"></div>
            </div>
            <div class="skeleton-toggle-grid">
                <div class="skeleton-toggle-item skeleton-block" *ngFor="let j of [1,2,3,4,5]"></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #permissionSkeleton>
    <div class="permission-grid">
        <div class="skeleton-toggle-item skeleton-block skeleton-permission-item" *ngFor="let i of [1,2,3,4,5,6]"></div>
    </div>
</ng-template>

<ng-template #tableSkeleton>
    <tr *ngFor="let i of [1,2,3,4,5]">
        <td><div class="skeleton-td-sno skeleton-block"></div></td>
        <td><div class="skeleton-td-text skeleton-block"></div></td>
        <td><div class="skeleton-td-actions skeleton-block"></div></td>
    </tr>
</ng-template>

<!-- ADD/EDIT REASON MODAL -->
<div class="modal-overlay" [class.show]="showReasonModal"
    (click)="$event.target === $event.currentTarget && closeReasonModal()">
    <div class="modal">
        <div class="modal-header">
            <h2 class="modal-title">
                <svg *ngIf="!editingReasonId" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor" class="modal-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                <svg *ngIf="editingReasonId" class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                </svg>
                {{ editingReasonId ? 'Edit Reason' : 'Add Reason' }}
            </h2>
            <button class="btn-close-modal" (click)="closeReasonModal()" title="Close Modal">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <form [formGroup]="reasonForm">
                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
                        </svg>
                        Reason Description
                        <span class="required">*</span>
                    </label>
                    <input type="text" class="form-input-modal" formControlName="description"
                        placeholder="Enter reason description">
                    <small class="error-text" *ngIf="
      reasonForm.get('description')?.invalid &&
      (reasonForm.get('description')?.touched || reasonForm.get('description')?.dirty)
    ">
                        Reason description is required
                    </small>
                </div>

                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z" />
                        </svg>
                        Category
                        <span class="required">*</span>
                    </label>
                    <select class="form-select-modal" formControlName="category" title="Select Category">
                        <option value="">Select Category</option>
                        <option value="unsuccessful">Order Unsuccessful</option>
                        <option value="cancelled">Order Cancel</option>
                    </select>
                    <small class="error-text" *ngIf="
                        reasonForm.get('category')?.invalid &&
                        (reasonForm.get('category')?.touched || reasonForm.get('category')?.dirty)
                        ">
                        Please select a category
                    </small>
                </div>
            </form>
        </div>

        <div class="modal-actions">
            <button class="btn-modal-secondary" (click)="closeReasonModal()">Cancel</button>
            <button class="btn-modal-primary" (click)="saveReason()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
                {{ editingReasonId ? 'Update Reason' : 'Add Reason' }}
            </button>
        </div>
    </div>
</div>
<!-- END ADD/EDIT REASON MODAL -->
<div class="popup-overlay" *ngIf="showManualPopup" (click)="closeManualPopup()"></div>

<div class="popup-container" *ngIf="showManualPopup">
    <div class="popup-header">
        <h3>Select Date Range</h3>
        <button class="close-btn" (click)="closeManualPopup()" title="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    </div>
    <div class="form-group">
        <label>From Date</label>
        <input type="date" [(ngModel)]="fromDate" title="From Date" placeholder="From Date">
    </div>

    <div class="form-group">
        <label>To Date</label>
        <input type="date" [(ngModel)]="toDate" title="To Date" placeholder="To Date">
    </div>

    <div class="popup-actions">
        <button class="btn cancel" (click)="closeManualPopup()">Cancel</button>
        <button class="btn apply" (click)="applyManualArchive()">Apply</button>
    </div>
</div>